import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResetpassword = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 21,
	viewBox: "0 0 16 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13 7.00276H16V21.0028H8H0V7.00276H11V5.00276C11 2.90276 8.85 1.31276 6.64 2.30276C5.6 2.76276 5 3.87276 5 5.00276H3C3 2.08276 5.51 -0.257236 8.49 0.0227641C11.09 0.272764 13 2.60276 13 5.21276V7.00276ZM7.3125 17.0804V18.3125H8.6875V17.0804H7.3125ZM9.49187 14.1047L10.1106 13.5379C10.5025 13.1868 10.75 12.6939 10.75 12.1518C10.75 10.7903 9.51937 9.6875 8 9.6875C6.48063 9.6875 5.25 10.7903 5.25 12.1518H6.625C6.625 11.4741 7.24375 10.9196 8 10.9196C8.75625 10.9196 9.375 11.4741 9.375 12.1518C9.375 12.4906 9.22375 12.7987 8.96937 13.0204L8.11687 13.7967C7.62187 14.2464 7.3125 14.8625 7.3125 15.5402V15.8482H8.6875C8.6875 14.9241 8.99687 14.5545 9.49187 14.1047Z",
		fill: "currentColor"
	})
});
export default SvgResetpassword;
